<template>
  <section class="project-gallery" id="project-gallery">
    <div class="container">
      <h2>{{ $t('projectGallery.title') }}</h2>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>{{ $t('projectGallery.columns.sector') }}</th>
              <th>{{ $t('projectGallery.columns.challenge') }}</th>
              <th>{{ $t('projectGallery.columns.solution') }}</th>
              <th>{{ $t('projectGallery.columns.impact') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(project, i) in $tm('projectGallery.projects')" :key="i">
              <td class="sector-cell">{{ project.sector }}</td>
              <td>{{ project.challenge }}</td>
              <td>{{ project.solution }}</td>
              <td class="impact-cell">{{ project.impact }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<style scoped>
.project-gallery {
  padding: 80px 20px;
  background-color: var(--white);
}

.container {
  max-width: 1100px;
  margin: 0 auto;
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 40px;
  text-align: center;
  color: var(--text-color);
}

.table-wrapper {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
  line-height: 1.6;
}

thead {
  background-color: var(--primary-color);
  color: white;
}

th {
  padding: 16px 20px;
  text-align: left;
  font-weight: 600;
}

td {
  padding: 16px 20px;
  border-bottom: 1px solid #e8e8e8;
  vertical-align: top;
}

tbody tr:hover {
  background-color: var(--gray-light, #f8f9fa);
}

.sector-cell {
  font-weight: 700;
  color: var(--primary-color);
  white-space: nowrap;
}

.impact-cell {
  font-weight: 600;
  color: var(--accent-color, #28a745);
}

@media (max-width: 768px) {
  .project-gallery {
    padding: 40px 15px;
  }
  h2 {
    font-size: 1.8rem;
  }
  table {
    font-size: 0.85rem;
  }
  th, td {
    padding: 12px 10px;
  }
}
</style>
